import styled from 'styled-components';
import { color } from 'styles/colors';

export const container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const itemBanner = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

export const clicks = styled.div`
  position: absolute;
  bottom: 0px;
  right: 0px;
  border-bottom-right-radius: 5px;
  border-top-left-radius: 5px;
  background-color: ${color.interface.darkgray2};
  padding: 1px 5px;
  font-weight: 900;
  font-size: 1.3rem;

  > p {
    font-size: 1rem;
    color: ${color.interface.white};
  }
`;

export const centralizeNotice = styled.div`
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;

  > p {
    font-size: 1.3rem;
    font-weight: 900;
    color: ${color.interface.lightGray};
  }
`;
